const moedaMascara = (valor: any) => {
    if (valor === null || valor === undefined) {
        return 'R$ 0,00'
    }
    const isNegative = valor.toString().includes('-')

    valor = valor.toString().replace(/\D/g, '')

    let numero = Number(valor) / 100
    
    if (isNegative) {
        numero = - numero
    }

    return numero.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    })
}

export default moedaMascara
